<template>
    <CToaster :autohide="1000" position="bottom-left">
        <CToast
            v-for="toast in CToastCounter"
            :class="CToast[toast].class"
            :key="'toast-'+toast"
            :show="true"
            :position="CToast[toast].position"
        >
            <template #header v-if="CToast[toast].header">
                <strong class="mfe-auto" v-html="CToast[toast].header"></strong>
            </template>
            <div v-html="CToast[toast].msg"></div>
        </CToast>
    </CToaster>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'ToastMe',
    computed: {
        ...mapGetters('toastComponent', [
            'CToast', 'CToastCounter'
        ])
    }
}
</script>